// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1HjCS","buttonWide":"styles_buttonWide__0rGRD"};